import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { TenantProvider } from './contexts/TenantContext';
import { Article } from './routes/pages/Article';
import { Ask } from './routes/pages/Ask';
import { Category } from './routes/pages/Category';
import { Home } from './routes/pages/Home';
import { NotFound } from './routes/pages/NotFound';

/**
 * help.auctisync.com — Module #2 Help Center + Module #33 white-label.
 *
 * Three route types:
 *   /              Home — browse categories
 *   /c/:slug       Category — list published platform articles in that category
 *   /a/:slug       Article — render markdown body
 *   /ask           Ask — AI Help Assistant chat widget
 *   *              NotFound
 *
 * Tenant-private articles surface in white-label mode (any host other than
 * help.auctisync.com) via the TenantProvider wrapping the routes. Platform
 * mode at help.auctisync.com leaves the tenant context null and serves only
 * platform articles, unchanged from Module #2.
 */
export function App() {
  return (
    <TenantProvider>
      <BrowserRouter>
        <Routes>
          <Route index element={<Home />} />
          <Route path="c/:slug" element={<Category />} />
          <Route path="a/:slug" element={<Article />} />
          <Route path="ask" element={<Ask />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
    </TenantProvider>
  );
}
